import LocalizedStrings from 'react-localization';
import {
    AGD_DOMAIN
} from '../config';

const lstrings = new LocalizedStrings({
	es: {
		actividad: "Actividad",
        actividades_title: "Actividades",
        actor: "Actor",
        agno: "Año",
        alta: "Alta",
        antecedentesmorosidad_title: "Antecedentes de morosidad (en créditos personales en nuestra base)",
        aportes_ref_0: "Pago en término",
        aportes_ref_1: "Pago fuera de término",
        aportes_ref_2: "No se registra información",
        aportesServDomestico_title: "Aportes empleado del servicio doméstico",
        aportesAutonomoMonotributo_title: "Aportes Autónomo / Monotributo",
        archivo: "Archivo",
        artVigente: "ART Vigente",
        automotores_title: "Automotores",
        autonomo_title: "Autónomo o Monotributista",
        baja: "Baja",
        balances_title: "Balances",
        bancos: "Bancos",
        bancosopera_title: "Bancos con los que opera",
        bienes_title: "Bienes",
        bienespersonales_title: "Bienes personales",
        bienvenida: "Hola {0}",
        bloque: "Bloque",
        boletin: "Boletín",
        boletinoficial_title: "Boletín Oficial",
        buscar: "Buscar",
        busquedarazonsocial_title: "Búsqueda por razón social",
        cantconsultaslotes: "Cantidad de consultas de Lotes",
        cantconsultasweb: "Cantidad de consultas Web",
        cantempaportes_title: "Cantidad de empleados que registran aportes (por año)",
        capitasDeclaradas: "Capitas Declaradas",
        caratula: "Carátula",
        cargo: "Cargo",
        causal: "Causal",
        cerrar: "Cerrar",
        categoria: "Categoría",
        chequesrechazados_title: "Cheques rechazados",
        coberturaart_title: "Cobertura ART Riesgos del Trabajo",
        codigo: "Código",
        codigoPostal: "Código Postal",
        comercioexterior_title: "Comercio Exterior",
        comparacionventasanual_title: "Comparación Ventas - Anual",
        compras: "Compras",
        condeconpymbesbcra: "Condición económica para PyMES según BCRA",
        condicion: "Condición",
        consultasexcedentes: "Consultas excedentes",
        consultasrestantes: "Consultas restantes",
        consumotarjeta_title: "Consumo tarjeta de crédito (en miles de pesos)",
        contactacion_title: "Contactación",
        contacto_mail: `consultas@${AGD_DOMAIN}`,
        contacto_tel: "011 5236 5371",
        contribucionautonomo: "Contribución autónomo",
        contribucionsegsocial: "Contribución seg. social autónomos",
        cp: "Código Postal",
        cuil: "CUIL",
        cuit: "CUIT",
        cuitcuil_title: "CUIT / CUIL",
        datosempresa_title: "Datos de la Empresa",
        datoslaborales_title: "Datos Laborales",
        datosparticulares_title: "Datos Particulares",
        demandado: "Demandado",
        descargar: "Descargar",
        descargarPdf: "Descargar a PDF",
        descripcion_title: "Descripción",
        desde: "Desde",
        deudoresbcra_title: "Deudores Banco central de la República Argentina",
        disclaimer_pdf: "La información que aquí se exhibe tiene el carácter de confidencial, reservada y no expresa juicio de valor alguno sobre su contenido o sobre la persona que se está consultando." + "\n\nAgilData Online o #cliente (#usuario) son los únicos habilitados y exclusivos consultantes de la información, quienes aceptan la expresa prohibición de la divulgación de esta a terceros total o parcialmente ya sea en forma onerosa o gratuita." +
            "\n\nSegún lo establece la Ley 25.326 de Protección de Datos Personales, Artículo 14, incisos 1 a 4: “El titular de los datos, previa acreditación de su identidad tiene derecho a solicitar y obtener información de sus datos personales incluidos en los bancos de datos públicos o privados destinados a proveer informes… en forma gratuita a intervalos no inferiores a seis meses...” (Derecho de acceso).",
        domicilio: "Domicilio",
        domiciliofiscal_title: "Domicilio Fiscal",
        domicilioparticular_title: "Domicilio Particular",
        emaildirs_title: "Direcciones de correo electrónico",
        emailsTitle: "Mails",
        embargo: "Embargo",
        embargos_title: "Embargos",
        emp_aportes_title: "Cantidad de empleados que registran aportes (por año)",
        empleado: "Empleado",
        empleadosdomesticos_title: "Empleados Domésticos",
        entidad: "Entidad",
        estado: "Estado",
        expediente: "Expediente",
        exportaciones: "Exportaciónes",
        facturacionult_title: "Facturacion (último año)",
        fecha: "Fecha",
        fecha_cese: "Fecha Cese",
        fecha_inicio: "Fecha Inicio",
        fechaconstitucion: "Fecha Constitución",
        fechadesde: "Fecha Desde",
        fechahasta: "Fecha Hasta",
        fechaLevantamiento: "Fecha Levantamiento",
        fechaPago: "Fecha de Pago",
        fechaPublicacion: "Fecha Publicación",
        fechaPresentacion: "Fecha de Presentación",
        fechaRechazo: "Fecha Rechazo",
        footer_pdf: "{0} - Página {1} de {2}",
        fuente: "Fuente",
        ganancias: "Ganancias",
        general_title: "General",
        generarReportePdf: "Generar Reporte en PDF",
        hasta: "Hasta",
        historialPrevisional_solicitud: "Solicitar Historial Laboral",
        historialPrevisional_solicitud_title: "Solicitar Información - Historial Laboral",
        historico_morosidad_title: "Histórico antecedentes de morosidad (en créditos personales en nuestra base)",
        id: "ID",
        importaciones: "Importaciones",
        importetotalpendiente: "Importe total pendiente:",
        importetotalrechazado: "Importe total rechazado:",
        imprimir: "Imprimir",
        impuesto_title: "Pago de Impuestos de Autónomos y Monotributistas",
        impuestos: "Impuestos",
        inculosotros_title: "Otros vínculos",
        infobcra1_pdf_title: "Información del BCRA Situación 1 - Según nuestros aportantes",
        infobcra_pdf_title: "Información del BCRA - Fuente: CD + Online (en miles de pesos)",
        infobcra_title: "Información del BCRA - Fuente: CD + Online",
        informe: "Informe",
        integrasociedades: "Integra Sociedades",
        iva: "IVA",
        juiciosactor_title: "Juicios - Actor",
        juiciosdemandado_title: "Juicios - Demandado",
        juzgado: "Juzgado",
        localidad: "Localidad",
        loginAccountExpiredException: "La cuenta de usuario ha expirado.",
        loginLockedException: "Usuario temporalmente bloqueado.",
        loginCredentialsExpiredException: "La contraseña expiró, se le enviará un email con instrucciones para el blanqueo.",
        login: "",
        loginDisabledException: "Usuario temporalmente deshabilitado.",
        loginBadCredentialsException: "Verfique usuario y contraseña.",
        loginAccessDeniedByIpException: "El acceso desde su IP no está autorizado.",
        loginFailed: "Ha ocurrido un error inesperado.",
        masaSalarialDeclarada: "Masa Salarial Declarada",
        masinfo: "Más Información",
        mes: "Mes",
        mes_abr: "Abr",
        mes_abril: "Abril",
        mes_ago: "Ago",
        mes_agosto: "Agosto",
        mes_dic: "Dic",
        mes_diciembre: "Diciembre",
        mes_ene: "Ene",
        mes_enero: "Enero",
        mes_feb: "Feb",
        mes_febrero: "Febrero",
        mes_jul: "Jul",
        mes_julio: "Julio",
        mes_jun: "Jun",
        mes_junio: "Junio",
        mes_mar: "Mar",
        mes_marzo: "Marzo",
        mes_may: "May",
        mes_mayo: "Mayo",
        mes_nov: "Nov",
        mes_noviembre: "Noviembre",
        mes_oct: "Oct",
        mes_octubre: "Octubre",
        mes_sep: "Sep",
        mes_septiembre: "Septiembre",
        modoliquidacion: "Modo Liquidación",
        monotributo: "Monotributo",
        monotributoautonomo: "Monotributo autónomo",
        monotributosegsocial: "Monotributo seg. social",
        monto: "Monto",
        morosidad_title: "Morosidad",
        multa: "Multa",
        nivelIngreso: "Nii",
        no_data: "No se encontraron datos",
        nombre: "Nombre",
        nombre_cia: "AgilData Online",
        notificaciones: "Notificaciones",
        notificaciones_no_data: "No hay notificaciones",
        nrotelefono: "Número de teléfono",
        nrocelular: "Número de celular",
        numeroOficio: "Nro. Oficio",
        numeroCheque: "Nro. Cheque",
        objeto: "Objeto",
        obrasocial_title: "Obra Social",
        obrasocialaportes: "Obra social aportes",
        obrasocialcontribuciones: "Obra social contribuciones",
        obrasocialretenciones: "Obra social retenciones",
        observaciones_title: "Observaciones",
        otros: "Otros",
        otrosdomicilios_title: "Otros Domicilios",
        padron: "Padrón",
        participacionotrassociedades: "Participación en otras sociedades",
        participacionsociedades_title: "Participación en Sociedades",
        participacionsocietaria_title: "Participación Societaria",
        pendientespago: "Pendientes Pago:",
        periodo: "Período",
        personas: "Personas",
        personasrelacempresa: "Personas relacionadas a la empresa",
        propiedades_title: "Propiedades",
        provincia: "Provincia",
        quiebras_concursos_title: "Quiebras y Concursos",
        rangoingreso: "Rango de ingreso",
        razonsocial: "Razón Social",
        referencias_title: "Referencias",
        relaciondependencia_title: "Relación de Dependencia",
        rol: "Rol",
        sector: "Sector",
        seguridadsocial_title: "Seguridad Social",
        seguridadsocialaportes: "Seguridad Social Aportes",
        seguridadsocialcontribuciones: "Seguridad Social Contribuciones",
        seguridadsocialretenciones: "Seguridad social retenciones",
        serverResponse500: "Estamos teniendo problemas para conectarnos con el servidor.",
        serverResponsePreconditionFailed: "No está permitido el acceso para el usuario. Espere unos segundos e intente ingresar nuevamente.",
        situacion_0: "Sin información en BCRA.",
        situacion_1: "Situación normal (pago puntual o atrasos menores a 31 días).",
        situacion_2: "Con riesgo potencial (con atrasos entre 31 y 90 días).",
        situacion_3: "Cumplimiento deficiente (con atrasos entre 90 y 180 días).",
        situacion_4: "Con alto riesgo de insolvencia (con atrasos entre 180 días y 1 año).",
        situacion_5: "Irrecuperable (con atrasos mayores a 1 año).",
        situacion_6: "Irrecuperable por disposición técnica (entidades liquidadas, en proceso de disolución o en quiebra, en gestión judicial).",
        situacion_title: "Situación",
        situacionFinanciera_title: "Situación Financiera",
        situacionfiscal_title: "Situación Fiscal",
        sociedadesComercialesTitle: "Sociedades Comerciales",
        solicitar_informacion_ok: "Se ha solicitado la información correctamente",
        solicitudes_adicionales: "Solicitudes Adicionales",
        subbloque: "Sub bloque",
        sueldopactadoinicio: "Sueldo pactado al inicio",
        sueldoscobrados_title: "Sueldos cobrados",
        sueldospagados_title: "Sueldos pagados",
        sueldospagos_title: "Sueldos Pagos",
        sumaFija: "Suma Fija",
        superficie_cubierta: "Superficie cubierta",
        superficie_terreno: "Superficie terreno",
        telefono: "Teléfono",
        telefonos_title: "Teléfonos",
        telefonosAdicionales: "Teléfonos adicionales",
        telefonosPrincipales: "Teléfonos principales",
        telefonosCelulares: "Teléfonos celulares",
        texto: "Texto",
        tipo: "Tipo",
        tipoabono: "Tipo de abono",
        tipolinea: "Tipo de línea",
        title: "Agil Data Online",
        titular: "Titular",
        total: "Total",
        total_consultas: "Total Consultas",
        total_pagado: "Total Pagado",
        ubicacion: "Ubicación",
        usuario: "Usuario",
        valorContratoAprox: "Valor Contrato Aprox.",
        variable: "Variable",
        ventas: "Ventas",
        verInformeCheques: "Ver informe de cheques denunciados",
        vigenciaabono: "Vigencia del abono",
        vinculos_title: "Vinculos",
        vinculosfam_title: "Vínculos familiares",
        vinculosotros_title: "Otros vínculos",
        jubilacion_title: "Jubilación",
    }
})

export default lstrings;



// WEBPACK FOOTER //
// ./src/utils/LStrings.js